export const prodConfig = {
  apiKey: 'AIzaSyCWNjMLJvIjDvJnpI-ks7S35B3mDKkXy8w',
  authDomain: 'drinkagenda.com',
  projectId: 'alcanon-20',
  storageBucket: 'alcanon-20.appspot.com',
  messagingSenderId: '176473135328',
  appId: '1:176473135328:web:e3145fe01b0941ce50d885',
  measurementId: 'G-4ZVM9TE9XZ',
  vapidKey:
    'BC9HQ9HG8c6HpiFqtsBr-P3An3L_SnwcI87HYVfElUddyKKonevkfk0zXKEqxzcPwfqzovlDHls7HywqSoj5KEI',
  recaptchaEnterpriseKey: '6LeOe34dAAAAAHa4vYaR5Kx4-Fq7e0aTBc8SYoVm',
};

export const stagingConfig = {
  apiKey: 'AIzaSyD1QF_c6lsC8Xps1J_0RRTN-4spjKJU8lg',
  authDomain: 'staging.drinkagenda.com',
  projectId: 'alcanon-staging',
  storageBucket: 'alcanon-staging.appspot.com',
  messagingSenderId: '622789748744',
  appId: '1:622789748744:web:68ab930dcdda9193be89bd',
  measurementId: 'G-ENGZZLFPM9',
  vapidKey:
    'BCVZJhKZpvcBkJ4DlQjraund9pcv4E98m6ZdIuX81QNKAxrZgF82Rn8BrJnwB6PUaLHEOg5Pr_muEcvmlxN1o9A',
  recaptchaEnterpriseKey: '6Lf5hoEdAAAAALBKMfQcxpAfPczs2tH-NLiMuFbZ',
};
